/**
 * @file Footer.
 */

import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

/**
 * Footer component.
 */
const vFooter = () => {
	const footer = document.querySelector('.v-footer');

	if (!footer) {
		return;
	}

	gsap.registerPlugin(ScrollToPlugin);

	const toTop = footer.querySelector('.v-footer__to-top');
	toTop.addEventListener('click', (e) => {
		e.preventDefault();
		gsap.to(window, {
			duration: 2,
			scrollTo: 0,
			onComplete: () => {
				document.querySelector('.v-main').focus();
			},
		});
	});
};

export default vFooter;
